import { GetterTree } from "vuex";
import { State } from "./state";

export default {
    medicalrep: (state: State) => state.medicalRep,
    medicalRepInitData: (state: State) => state.medicalRepInitialData,
} as GetterTree<State, any>;
